import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootStates } from 'redux/store';
import { apiUrl } from '../../constants/paths';

export const projectApi = createApi({
  reducerPath: 'projectApi',
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootStates).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    addProject: build.mutation({
      query: (body) => ({
        url: apiUrl.project,
        method: 'POST',
        body: body.values,
      }),
    }),
    getProjectById: build.mutation({
      query: (id) => ({
        url: apiUrl.project + `/${id}`,
        method: 'GET',
      }),
    }),
    getProjects: build.mutation({
      query: () => ({
        url: apiUrl.project,
        method: 'GET',
      }),
    }),
    deleteProjectById: build.mutation({
      query: (id) => ({
        url: apiUrl.project + `/${id}`,
        method: 'DELETE',
      }),
    }),
    uploadDocuments: build.mutation({
      query: (body) => ({
        url: apiUrl.project + `/${body.projectId}/documents`,
        method: 'POST',
        body: body.values,
      }),
    }),
    updateDocuments: build.mutation({
      query: (body) => ({
        url: apiUrl.project + `/${body.projectId}/documents`,
        method: 'PATCH',
        body: body.values,
      }),
    }),
    uploadAsset: build.mutation({
      query: (body) => ({
        url: apiUrl.uploadAsset,
        method: 'POST',
        body,
      }),
    }),
    getAllTasks: build.mutation({
      query: ({ projectId = '', taskType = '', page = 1, limit = 16 }) => ({
        url: `users/tasks?projectId=${projectId}&status=OPEN&taskType=${taskType}&page=${page}&limit=${limit}`,
        method: 'get',
      }),
    }),
    getNotifications: build.mutation({
      query: ({
        projectId = '',
        page = 1,
        limit = 16,
        notificationType = 'project',
      }) => ({
        url: `users/notifications?projectId=${projectId}&page=${page}&limit=${limit}&notificationType=${notificationType?.toUpperCase()}`,
        method: 'get',
      }),
    }),
    getUnreadNotificationCount: build.mutation({
      query: () => ({
        url: 'users/notifications/counts',
        method: 'get',
      }),
    }),
    markAllNotificationAsRead: build.mutation({
      query: () => ({
        url: `users/notifications`,
        method: 'PATCH',
        body: { hasRead: true },
      }),
    }),
  }),
});

export const {
  useAddProjectMutation,
  useGetProjectByIdMutation,
  useGetProjectsMutation,
  useDeleteProjectByIdMutation,
  useUploadDocumentsMutation,
  useUploadAssetMutation,
  useGetAllTasksMutation,
  useGetNotificationsMutation,
  useMarkAllNotificationAsReadMutation,
  useUpdateDocumentsMutation,
  useGetUnreadNotificationCountMutation,
} = projectApi;
